<form [formGroup]="_formGroupSearch" class="search-filters-group">
    <div class="form-row">

        <div class="col-12 col-md-4 col-sm-6">
            <form-group-checkbox-multi-accordion [id]="'filter-position'"  [placeholder]="'Cargos'"
                [placeholderSearch]="'Buscar cargo'" [dataSelectGroup]="POSITION_GROUPED" [pipe]="'position'"
                [controlArray]="optionPosition"></form-group-checkbox-multi-accordion>
        </div>

        <div class="col-12 col-md-4 col-sm-6">
            <form-group-checkbox-multi-accordion #filterAddress3 [id]="'filter-address3'"  [placeholder]="'Comunas'"
                [placeholderSearch]="'Buscar comuna'" [dataSelectGroup]="ADDRESS3_GROUPED" [pipe]="'address3'"
                [controlArray]="optionAddress3"
                [textSelectAllGroup]="'Todas las comunas'"></form-group-checkbox-multi-accordion>
        </div>
        <div class="col-12 col-md-4 col-sm-6">
            <div class="form-group">
                <div class="search-input-with-btn">
                    <label for="input-search-ad" class="accesibleHidden">Buscador de
                        anuncios
                    </label>
                    <input formControlName="optionFilter" type="search" class="form-control "
                        id="input-search-ad" placeholder="Ingrese una búsqueda, ejemplo: Matemáticas"
                        title="Buscador de anuncios" />
                    <button (click)="onActionSearch()" class="btn btn-search" title="Buscar anuncios"><i
                            class="pj-ico pj-ico-buscar"></i>
                    </button>
                </div>


            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="col-12 col-lg-4 col-sm-6 col-xl-3" *ngIf="showCategory">

            <form-group-checkbox-multi [id]="'filter-category'" [placeholder]="'Categorías'"
                [placeholderSearch]="'Buscar categoría'" [dataSelectLabel]="POSITION_CATEGORY_LIST"
                [controlArray]="optionCategory" [enabledCountControl]="false" [onlyAvailableFilter]="false"
                [enabledFilter]="true" [style]="'purple'">
            </form-group-checkbox-multi>

        </div>
        <div class="col-12 col-lg-4 col-sm-6 col-xl-3">

            <form-group-checkbox-multi [id]="'filter-level'" [placeholder]="'Ciclos'"
                [placeholderSearch]="'Buscar ciclo'" [dataSelectLabel]="LEVEL_LIST" [controlArray]="optionLevel"
                [enabledCountControl]="false" [onlyAvailableFilter]="false" [enabledFilter]="true" [style]="'purple'">
            </form-group-checkbox-multi>
        </div>

        <div class="col-12 col-lg-4 col-sm-6 col-xl-3" *ngIf="filterNextSeason">

            <div class="form-group">
                <div class="text-uppercase wrap-checkbox mgn-top-5 text-white">

                    <input-check class="text-white" [control]="optionNextSeason" [id]="'filter-next-season'"
                        [title]="'Solo cargos 2026'" [style]="'white'"></input-check>
                </div>
            </div>
        </div>

    </div>
</form>